import { render, staticRenderFns } from "./DeletedItems.vue?vue&type=template&id=2f7a1577"
import script from "./DeletedItems.vue?vue&type=script&lang=js"
export * from "./DeletedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports